import React, { useState } from "react";
import { ChevronLeftIcon, ChevronRightIcon } from "./icons";

function ToggleChevron({ onClick }: { onClick: () => void }) {
  const [isOpen, setIsOpen] = useState<boolean>(true);

  const clicker = () => {
    setIsOpen(!isOpen);
    onClick();
  };

  return (
    <button onClick={clicker}>
      {isOpen && <ChevronRightIcon />}
      {!isOpen && <ChevronLeftIcon />}
    </button>
  );
}

export default ToggleChevron;
